import React from 'react';
import COLOR from "../../Styles/Colors";
import { TooltipHost, Persona, PersonaSize, Stack, Image, ImageFit } from '@fluentui/react';
import { FontSizes } from '@uifabric/fluent-theme/lib/fluent/FluentType';
import { AppButton } from "../Accessary";
import { useSelector, useDispatch } from 'react-redux';
import Type from "../../Redux/Type";
import { onOpenRightPanel } from "../../Containers/RightPanelAction";

const HeaderBar = () => {
    const userInfo = useSelector(state => state.userInfo);
    const dispatch = useDispatch();
    const { isLoading, messageLoading } = useSelector(state => state.loadingState);
    const { showTool } = useSelector(state => state.drawingTool);
    const { routeContent } = useSelector(state => state.rightPanel);

    const onButtonPress = (route) => () => onOpenRightPanel(route)
    const onDrawingPress = () => {
        if (showTool) {
            dispatch({ type: Type.CLEAR_PATH_DRAWING });
            dispatch({ type: Type.SHOW_OFF_DRAWING });
        }
        else {
            dispatch({ type: Type.SHOW_ON_DRAWING });
            dispatch({ type: Type.START_DRAWING })
        }
    }


    return (
        <div className=' position-fixed container-fluid d-flex row m-0 align-items-center p-0' style={styles.topBar}>
            <TooltipHost
                content={'Cổng thông tin đất đai tỉnh Cà Mau'}
                styles={{ root: { display: 'inline-block', marginLeft: 10 } }}
            >
                <Stack horizontal verticalAlign={"center"}>
                    <Image
                        src={require("../../Assets/icon.png")}
                        imageFit={ImageFit.contain}
                        width={32}
                        height={32}
                    />
                    <a
                        // href={'https://dl.dropbox.com/s/y0ldaibfmgqq0ry/manifest.plist'} 
                        style={styles.title}>Cổng thông tin đất đai tỉnh Cà Mau</a>
                </Stack>
            </TooltipHost>
            <div style={{ fontSize: 12, paddingLeft: 10, color: 'white' }}>

                <span>{isLoading === true ? messageLoading : null}</span>
            </div>
            <div style={{ flex: 1 }} />
            {/* {userInfo ?
                <AppButton
                    iconName={'EditCreate'}
                    tooltip={'Vẽ quy hoạch'}
                    active = {showTool}
                    onClick = {onDrawingPress}
                />
                : null
            }

            {appButton.map(item=>(
                <AppButton
                    key = {item.key}
                    iconName={item.iconName}
                    tooltip={item.tooltip}
                    active = {routeContent === item.key}
                    onClick = {onButtonPress(item.key)}
                />
            ))} */}
            {/* <div>
                {userInfo ?
                    <TooltipHost
                        content={'Tài khoản'}
                    >
                        <div style={styles.accountBtn} className='btn-custom' onClick={onButtonPress('account')}>
                            <Persona hidePersonaDetails size={PersonaSize.size32} />
                        </div>
                    </TooltipHost>
                    :
                    <AppButton
                        iconName={'Contact'}
                        tooltip={'Đăng nhập'}
                        active={routeContent === 'login'}
                        onClick={onButtonPress('login')}
                    />
                }
            </div> */}
        </div>
    )
};

const appButton = [
    { key: 'search', iconName: 'Search', tooltip: 'Tìm kiếm' },
    { key: 'layer', iconName: 'MapLayers', tooltip: 'Quy hoạch' }, //layer
    { key: 'satellite', iconName: 'Nav2DMapView', tooltip: 'Chế độ xem' },
    { key: 'location', iconName: 'List', tooltip: 'Chuyển vị trí' },
    // {key:'server',iconName:'ServerEnviroment',tooltip:'Chuyển Sever'},
    // {key:'help',iconName:'Help',tooltip:'Hướng dẫn'}
];


export default HeaderBar;

const styles = {
    topBar: {
        backgroundColor: COLOR.blue,
        minHeight: 48
    },
    appName: {
        fontSize: FontSizes.size14,
        fontWeight: 600,
        color: COLOR.blue,
        marginLeft: 10
    },

    accountBtn: {
        height: 48,
        width: 48,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer'
    },
    title: {
        fontSize: 14,
        color: COLOR.white,
        paddingLeft: 10,
        fontWeight: 700,
        cursor: 'pointer'
    }
};


